export default {
  salesForceSubmit(bodyParams = {}, params = {}) {
    const body = new FormData()
    body.append('oid', '00Dw0000000mJDY')
    body.append('retURL', 'https://www.sovemagroup.com')

    console.log(bodyParams)

    const bodyKeys = {
      salutation: '00N7R00000BANkQ',
      firstName: 'first_name',
      lastName: 'last_name',
      company: 'company',
      email: 'email',
      jobTitle: '00N7R00000BANka',
      department: '00N7R00000BANl9',
      mobile: 'mobile',
      emailOptOut: 'emailOptOut',
      privacyAcceptanceDate: '00N7R00000BANld',
      chemistry: '00Nw0000008EYcT',
      touchPointDate: '00N7R00000BANqT',
      touchPointAction: '00N7R00000BANqY',
      touchPointSubject: '00N7R00000BANqd',
      touchPointName: '00N7R00000BANrb',
      touchPointMessage: '00N7R00000BANxo',
      url: 'url',
      leadSource: 'lead_source',
      country: 'country_code',
      street: 'street',
      zip: 'zip',
      newsletter: '00N7R00000CRBH3' // Not confirmed, Subscribed, Unsubscribed
    }

    bodyParams = Object.assign({
      leadSource: 'Product Website',
      touchPointName: 'Product Website'
    }, bodyParams)

    Object
      .keys(bodyKeys)
      .forEach(key => {
        if (bodyParams[key]) {
          body.append(bodyKeys[key], bodyParams[key])
        }
      })

    const headers = new Headers()
    headers.append('Authorization', `Basic ${btoa('api@luglio7.com:w~,,V&"2=UMaq3C@')}`)

    return fetch(
      '/api/sovema/salesforce',
      Object.assign(
        {
          method: 'POST',
          headers,
          body
        },
        params
      )
    )
  }
}
